import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-bootstrap'
import CalcSection from './CalcSection'
import CalcParagraph from './CalcParagraph'
import NavBtn from './NavBtn'
import NavBar from './NavBar'
import * as forms from '../forms/form'
import FormattedConnectedInput from '../forms/FormattedConnectedInput'
import ALink from './ALink'
import HelpFilter from './HelpFilter'

/**
 * Basic component for rendering Section 5 of the calculator
 */
export default class Section5 extends Component {
  /**
   * Render component
   */
  render () {
    return (
      <CalcSection title={this.props.title}>
        <CalcParagraph>
          Let's capture some basic elements. First, estimate how many years
          until you plan on retiring.
        </CalcParagraph>
        <Form style={forms.formWrapperStyle} horizontal>
          <FormattedConnectedInput
            label={forms.yearsUntilRetirementLabel}
            reduxKey={forms.yearsUntilRetirementKey}
            numberForm
          />
        </Form>
        <CalcParagraph>
          Second, estimate how many years you plan to be in retirement. This can
          be tough.
          <HelpFilter showLevel={[1, 2]}>
            Clearly life expectancy is the key component and no one really knows
            how long they'll travel this earth.
            <HelpFilter showLevel={[1]}>
              That unknown provides a significant dose of uncertainty and few
              people enjoy uncertainty particularly when it comes to something
              as important as financing their retirement. My advice is to do a
              little research.
            </HelpFilter>{' '}
            There is a decent
            <ALink href='https://www.myabaris.com/tools/life-expectancy-calculator-how-long-will-i-live/'>
              life expectancy calculator here
            </ALink>
            but note that you will have to provide a valid email address to get
            the results. If you would rather move on, just using an average and
            adding five or ten years as a buffer may be as good a guess as any.
            Averages by country and gender can be found{' '}
            <a
              href='https://en.wikipedia.org/wiki/List_of_countries_by_life_expectancy'
              target='_blank'
              rel='noopener noreferrer'
            >
              here
            </a>.
            <HelpFilter showLevel={[1]}>
              You may want to consider that money you leave behind can always go
              to your family or can be donated to a charity. Clearly there are
              several factors to this decision and ultimately it is a personal
              choice and there is no one right answer. Evaluate the aspects of
              this choice that are important to you and make an estimate.
            </HelpFilter>
          </HelpFilter>
        </CalcParagraph>
        <Form style={forms.formWrapperStyle} horizontal>
          <FormattedConnectedInput
            label={forms.yearsInRetirementLabel}
            reduxKey={forms.yearsInRetirementKey}
            numberForm
          />
        </Form>
        <CalcParagraph>
          The last thing we'll capture in this section is the average inflation
          rate you expect over the rest of your lifetime.
          <HelpFilter showLevel={[1, 2]}>
            We'll use this to adjust your monthly costs over time to accurately
            calculate your retirement plan.
          </HelpFilter>{' '}
        </CalcParagraph>
        <CalcParagraph>
          <HelpFilter showLevel={[1, 2]}>
            <HelpFilter showLevel={[1]}>
              Basically, inflation always exists in an economy. Among other
              things, it can indicate that an economy is healthy or not.
              Generally it is healthy for an economy to have some small amount
              of inflation. In the US,
              <ALink href='https://inflationdata.com/Inflation/Inflation_Rate/Long_Term_Inflation.asp'>
                the historical average since 1913
              </ALink>
              (when the government started keeping track) has been about 3%. No
              one knows for certain what the rate of inflation will be over the
              next five years much less the next twenty to fifty years. But we
              need to account for it as best we can because inflation will
              almost certainly impact the price of goods in the future and that
              increases costs in retirement.
            </HelpFilter>{' '}
            Unless you feel strongly about your own estimate, it is probably
            best to simply use the 3% average. If you want to be very
            conservative, use 4%.
          </HelpFilter>{' '}
        </CalcParagraph>
        <Form style={forms.formWrapperStyle} horizontal>
          <FormattedConnectedInput
            label={forms.inflationEstimateLabel}
            reduxKey={forms.inflationEstimateKey}
            percentForm
          />
        </Form>
        <NavBar>
          <NavBtn nextSection={4} back />
          <NavBtn nextSection={6} />
        </NavBar>
      </CalcSection>
    )
  }
}

CalcSection.propTypes = {
  title: PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./src/components/sections/Section5Timing.js